<template>
    <transition>
        <div class="dialog-modal-mask">
            <div class="small-panel">
                <div class="dialog-title" v-t="'message.title_stt_extension_p2p_engine_setting_dialog'">
                </div>

                <hr class="dialog-hr">
                <div class="object-titlebox">
                    <div class="title-box-left">
                        <span v-t="'message.item_stt_extension_select_p2p_stt_engine'"/>
                    </div>
                </div>
                <el-select class="select-option-item" v-model="selectedSttEngineType" @change="handleOptionChange('speechToTextEngine')">
                    <el-option v-for="speechEngine in speechEngineList" :key="speechEngine.type" :label="speechEngine.displayName" :value="speechEngine.type" >
                        <template v-if="speechEngine.tooltip">
                            <span style="float: left; margin-right: 4px;">{{ speechEngine.displayName }}</span>
                            <el-tooltip effect="dark" placement="top-start">
                                <div slot="content" style="text-align:left" v-html="speechEngine.tooltip"></div>
                                <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                            </el-tooltip>
                        </template>
                    </el-option>
                </el-select>

                <div class="object-titlebox">
                    <div class="title-box-left">
                        <span v-t="'message.item_stt_extension_select_p2p_translation_engine'"/>
                    </div>
                </div>
                <el-select class="select-option-item" v-model="selectedTranslationEngineType" @change="handleOptionChange('translationEngine')">
                    <el-option v-for="translationEngine in translationEngineList" :key="translationEngine.type" :label="translationEngine.displayName" :value="translationEngine.type"></el-option>
                </el-select>

                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')"
                               v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="save">OK</el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonUtil from '@/components/commonutil.js';

export default {
    props: ['sttEngine', 'translationEngine'],

    data() {
        return {
            speechEngineList: [],
            translationEngineList: [],
            P2PEngineInfo: [],
            selectedSttEngineType: {},
            selectedTranslationEngineType: {},

            beforeSttEngine: {},
            beforeTranslationEngine: {},
        };
    },

    created: function () {
        this.speechEngineList = commonUtil.getSpeechToTextEngineListForPlanLicense(this.$i18n);
        for (let i = 0; i < this.speechEngineList.length; i++) {
            // if(this.speechEngineList[i].type === 0){
            //     this.speechEngineList.splice(i,1);
            //     break;
            // }
        }
        this.translationEngineList = commonUtil.getTranslationEngineList(this.$i18n);
        for(let i = 0; i < this.translationEngineList.length; i++) {
            // if(this.translationEngineList[i].type === 0) {
            //     this.translationEngineList.splice(i, 1);
            // }
        }

        if (this.sttEngine === 2) {
            // Google engine is not be able to select.
            this.selectedSttEngineType = 1
            this.beforeSttEngine = 1
        } else {
            this.selectedSttEngineType = this.sttEngine
            this.beforeSttEngine = this.sttEngine
        }
        this.selectedTranslationEngineType = this.translationEngine
        this.beforeTranslationEngine = this.translationEngine
    },

    methods: {
        save() {
            let sttEngineTypeToEmit = this.selectedSttEngineType !== this.sttEngine ? this.selectedSttEngineType : null;
            let translateEngineTypeToEmit = this.selectedTranslationEngineType !== this.translationEngine ? this.selectedTranslationEngineType : null;

            if (sttEngineTypeToEmit !== null || translateEngineTypeToEmit !== null) {
                this.$emit('setEngine', sttEngineTypeToEmit, translateEngineTypeToEmit);
            } else {
                this.$emit('cancel');
            }
        },
        handleOptionChange(changedOption) {
            switch(changedOption) {
                case "speechToTextEngine" :
                    if (this.selectedSttEngineType === 0) {
                        if (this.selectedTranslationEngineType > 0) {
                            commonUtil.notifyMessage(this, 'Warning', commonUtil.getMessageText(this.$i18n,"error_need_disable_translation"));
                            this.selectedSttEngineType = this.beforeSttEngine;
                            return;
                        }
                    }
                    this.beforeSttEngine = this.selectedSttEngineType;
                    break;
                case "translationEngine" :
                    if (this.selectedTranslationEngineType > 0) {
                        if (this.selectedSttEngineType == 0) {
                            commonUtil.notifyMessage(this, 'Warning', commonUtil.getMessageText(this.$i18n,"error_need_enable_speechToText"));
                            this.selectedTranslationEngineType = this.beforeTranslationEngine;
                            return;
                        }
                    }
                    this.beforeTranslationEngine = this.selectedTranslationEngineType;
                    break;
            }
        }
    }
}
</script>

<style scoped>
.title-box-left {
    padding: 10px 10px 10px 20px;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}

.dialog-button-field {
    padding-top: 12px;
    padding-bottom: 12px;
    padding-right: 20px;
    text-align: right;
    vertical-align: middle;
}

.select-option-item {
    margin: 12px;
}
</style>
